import type { PartyWrapped } from '@mixwire/contracts';

export type NightWindow = {
  readonly startMs: number;
  readonly endMs: number;
};

/**
 * A party's `endedAt` is when the room was shut down, which can be hours — or days — after the
 * last deck went quiet. The recap is a picture of the music, so the window closes with the last
 * stint on record and only falls back to the party's own end when no stint says otherwise.
 */
export const nightWindow = (wrapped: PartyWrapped): NightWindow => {
  const startMs = Date.parse(wrapped.party.createdAt);
  const partyEndMs =
    wrapped.party.endedAt === null
      ? startMs + Math.max(wrapped.durationMs, 1)
      : Date.parse(wrapped.party.endedAt);

  const stintEndsMs = wrapped.stints.map((stint) =>
    stint.endedAt === null ? partyEndMs : Date.parse(stint.endedAt),
  );

  const endMs =
    stintEndsMs.length === 0 ? partyEndMs : Math.min(partyEndMs, Math.max(...stintEndsMs));

  return { startMs, endMs: Math.max(endMs, startMs + 1) };
};
